import React, { createContext, useContext, useState } from 'react'

const PlayerCountContext = createContext()

export const PlayerCountProvider = ({ children }) => {
  const [playerCount, setPlayerCount] = useState(null)

  return (
    <PlayerCountContext.Provider value={{ playerCount, setPlayerCount }}>
      {children}
    </PlayerCountContext.Provider>
  )
}

export const usePlayerCountContext = () => {
  const context = useContext(PlayerCountContext)
  if (!context) {
    // Si pas de provider, retourner des valeurs par défaut
    return { playerCount: null, setPlayerCount: () => {} }
  }
  return context
}
